export const ColumnsRates = [
  {
    headerName: "ID",
    type: "string",
    value: {
      first: {
        value: "id",
      },
    },
  },
  {
    headerName: "Nome",
    type: "string",
    value: {
      first: {
        value: "nome",
      },
    },
    noData: "Boi Gordo SP",
  },
  {
    headerName: "Dia",
    type: "date",
    value: {
      first: {
        value: "date_rate",
      },
    },
  },
  {
    headerName: "Username",
    type: "string",
    value: {
      first: {
        value: "username",
      },
    },
  },
  {
    headerName: "Valor",
    type: "money",
    value: {
      first: {
        value: "value_rate",
      },
    },
  },
  {
    headerName: "Criado em",
    type: "date",
    value: {
      first: {
        value: "created_at",
      },
    },
  },
  {
    headerName: "Atualizado em",
    type: "date",
    value: {
      first: {
        value: "updated_at",
      },
    },
  },
];

export const indicators = [
  {
    id: 340,
    date_rate: "2021-08-05T03:00:00.000Z",
    value_rate: 100,
    username: "PRIMEIRA_CARGA",
    created_at: "2021-08-05T17:53:22.282Z",
    updated_at: "2021-08-05T17:53:22.282Z",
  },
  {
    id: 340,
    date_rate: "2021-08-05T03:00:00.000Z",
    value_rate: 100,
    username: "PRIMEIRA_CARGA",
    created_at: "2021-08-05T17:53:22.282Z",
    updated_at: "2021-08-05T17:53:22.282Z",
  },
  {
    id: 340,
    date_rate: "2021-08-05T03:00:00.000Z",
    value_rate: 100,
    username: "PRIMEIRA_CARGA",
    created_at: "2021-08-05T17:53:22.282Z",
    updated_at: "2021-08-05T17:53:22.282Z",
  },
];